import { createContext, useContext, useState, useCallback } from 'react';

const ToastCtx = createContext(null);

export function ToastProvider({ children }) {
  const [toast, setToast] = useState({ msg: '', show: false, err: false });

  const showToast = useCallback((msg, err = false) => {
    setToast({ msg, show: true, err });
    setTimeout(() => setToast(t => ({ ...t, show: false })), 5000);
  }, []);

  return (
    <ToastCtx.Provider value={showToast}>
      {children}
      <div className={`toast${toast.show ? ' show' : ''}${toast.err ? ' err' : ''}`}>
        {toast.msg}
      </div>
    </ToastCtx.Provider>
  );
}

export const useToast = () => useContext(ToastCtx);
